var premiumContentInterstellar = {};
var premiumContentSlider = $('.js-premium-content-slider');
premiumContentInterstellar.slider = function () {
  if (premiumContentSlider.length === 0) {
    return;
  }
  $.each(premiumContentSlider, function () {
    var $slider = $(this);
    var cellAlignment = 'left';
    var sliderLength = $slider.find('.js-premium-content-slider-item').length;
    if (matchMedia('screen and (max-width: 991px)').matches) {
      cellAlignment = 'center';
    }
    if (sliderLength > 1) {
      $slider.flickity({
        cellAlign: cellAlignment,
        contain: true,
        prevNextButtons: sliderLength > 2 ? true : false,
        wrapAround: true,
        draggable: sliderLength > 2 ? true : false,
        pageDots: sliderLength > 2 ? true : false,
        dragThreshold: 10,
        on: {
          ready: function ready() {
            $slider.removeClass('invisible');
          }
        }
      });
    } else {
      $slider.removeClass('invisible');
    }
  });
};
premiumContentInterstellar.sliderItemClick = function () {
  if (premiumContentSlider.length === 0) {
    return;
  }
  $.each(premiumContentSlider, function () {
    var $slider = $(this);
    $slider.find('.premium-content-slider-item').click(function (e) {
      e.preventDefault();
      var $sliderItem = $(this);
      if (matchMedia('screen and (max-width: 991px)').matches) {
        if ($sliderItem.hasClass('is-hover')) {
          window.location.href = $sliderItem.data('link');
          return;
        } else {
          $sliderItem.addClass('is-hover');
        }
      }
      if (matchMedia('screen and (min-width: 992px)').matches) {
        window.location.href = $sliderItem.data('link');
      }
    });
  });
};
premiumContentInterstellar.slider();
premiumContentInterstellar.sliderItemClick();
window.premiumContentInterstellar = premiumContentInterstellar;


// WEBPACK FOOTER //
// ./scripts/components/sliders/interstellar/premium-content.js